const data = {
    module_name: "contactos",
    title: "Contactos",
    key: 'contacts',
    category_key: "contacto",
    excel_key: "contacts"
}

module.exports = data